import axios from "@/axios.js";

export default {
  addItem({ commit }, item) {
    debugger;
    return new Promise((resolve, reject) => {
      debugger;
      axios
        .post("API/Lookup/AddUnitOwnerType", item)
        .then(response => {
          debugger;
          resolve(response);
          commit(
            "ADD_ITEM",
            Object.assign(item, { ID: response.data.data.ID })
          );
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  fetchDataListItems({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("API/Lookup/GetAllUnitOwnerType")
        .then(response => {
          resolve(response);
          commit("SET_UintOwnerTypes", response.data.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  updateItem(context, item) {
    debugger;
    return new Promise((resolve, reject) => {
      axios
        .put("API/Lookup/UpdateUnitOwnerType", item)
        .then(response => {
          resolve(response);
         // commit("UPDATE_UnitOwner", item);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  GetItemByID(context, itemid) {
    return new Promise((resolve, reject) => {
      debugger;
      axios
      .get("API/Lookup/GetUnitOwnerTypeById?Id=" + itemid)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  DeleteUnitOwner({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .delete("API/Lookup/DeleteUnitOwnerType?Id=" + item.id)
        .then(response => {
          resolve(response);
          commit("REMOVE_ITEM", item.ID);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

};
